import router from '@/router'
import { useAuth } from '@simplifi/auth'
import type { LDMultiKindContext } from 'launchdarkly-js-client-sdk'
import { ldInit, useLDFlag } from 'launchdarkly-vue-client-sdk'

export function init() {
  const { session, loggedIn } = useAuth()

  if (!loggedIn.value) {
    throw new Error('Attempted to initialize LaunchDarkly without a session')
  }

  const context: LDMultiKindContext = {
    kind: 'multi',
    user: {
      anonymous: false,
      key: session.value.userId,
      name: session.value.userName,
      email: session.value.email,
    },
  }

  try {
    const [, client] = ldInit({ context })
    client.on('failed', (err) => {
      console.error('LD Failed to init', err)
      router.push({ name: 'permissionError' })
    })
    client.on('error', (err) => {
      console.error('LD Errored on init', err)
      router.push({ name: 'permissionError' })
    })
    return client
  } catch (error) {
    console.error('LD Failed to init', error)
  }

  router.push({ name: 'permissionError' })
}

export function useFlag(flagName: string, defaultValue = false) {
  try {
    return useLDFlag(flagName, defaultValue)
  } catch {
    return defaultValue
  }
}
